/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from "react";
import SDPageHeader from "../SDPageHeader";
import { sdCreateRequest, sdMakeRequests, sdRequestsCompleted, sdRenderLoadingOrError, sdUTCTimestampStrToLocalStr, sdTruncateString, sdGetStatusColour, sdGetPriorityColour, sdCamelCaseToFriendlyText, sdGetSelectedProjectId } from "helpers/sdHelper";
import { sdGetProjects, sdGetMe, sdGetQueue } from "services/service-desk/sdService";
import { Card } from "react-bootstrap";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import AdvanceTableWrapper from "components/common/advance-table/AdvanceTableWrapper";
import AdvanceTableFooter from "components/common/advance-table/AdvanceTableFooter";
import SDUserBadge from "../SDUserBadge";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

const SDQueue = () => {
    const { queueType } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [me, setMe] = useState(null);
    const [projects, setProjects] = useState([]);
    const [queueData, setQueueData] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [selectedProjectId, setSelectedProjectId] = useState(sdGetSelectedProjectId());

    useEffect(() => {
        let allRequests = [
            sdCreateRequest(() => sdGetProjects(), setProjects),
            sdCreateRequest(() => sdGetMe(), setMe),
            sdCreateRequest(() => sdGetQueue(1, queueType), setQueueData),
        ];

        sdMakeRequests(allRequests, setLoading, setError);
    }, [queueType]);

    useEffect(() => {
        reloadQueueData();
    }, [selectedProjectId]);

    const reloadQueueData = () => {
        sdGetQueue(selectedProjectId, queueType).then(res => {
            setQueueData(res.data)
        }).catch(err => {

        });
    }

    const getUserSimple = (user, defaultName) => {
        if (user === null || user === 0) {
            return defaultName;
        }

        return <span>&nbsp;<SDUserBadge user={user}></SDUserBadge>{user.displayName}</span>
    }

    useEffect(() => {
        if (!queueData) return;

        let res = [];
        for (let i = 0; i < queueData.length; i++) {
            let issue = queueData[i];
            let tableRow = {};
            if (!issue) continue;

            let reportedBy = issue.reportedBy;
            
            tableRow.id = issue.id;
            tableRow.key = issue.key;
            tableRow.subject = sdTruncateString(issue.subject, 42);
            tableRow.status = <ColorCircleWithText color={sdGetStatusColour(issue.status.type)} text={issue.status.name}></ColorCircleWithText>
            tableRow.priority = <ColorCircleWithText color={sdGetPriorityColour(issue.priority.value)} text={ issue.priority.name}></ColorCircleWithText>;
            tableRow.category = issue.category ? issue.category.name : 'No Category'
            tableRow.reportedBy = getUserSimple(issue.reportedBy, 'Unknown')
            tableRow.assignedTo = getUserSimple(issue.assignedTo, 'Unassigned')
            tableRow.created = sdUTCTimestampStrToLocalStr(issue.created)
            tableRow.updated = sdUTCTimestampStrToLocalStr(issue.updated)

            res.push(tableRow)
        }
        setTableData(res);
    }, [queueData]);

    if (!sdRequestsCompleted(loading, error)) {
        return sdRenderLoadingOrError(loading, error);
    }

    console.log("queueData", queueData);

    const columns = [
        {
            accessor: 'key',
            Header: 'Key',
            Cell: rowData => {
                const { id, key } = rowData.row.original
                return (
                    <><Link to={`/service-desk/issue/${id}`} rel="noreferrer">{key}</Link></>
                )
            }
        },
        {
            accessor: 'subject',
            Header: 'Subject',
        },
        {
            accessor: 'status',
            Header: 'Status',
        },
        {
            accessor: 'category',
            Header: 'Category',
        },
        {
            accessor: 'priority',
            Header: 'Priority',
        },
        {
            accessor: 'reportedBy',
            Header: 'Reported By',
        },
        {
            accessor: 'assignedTo',
            Header: 'Assigned To',
        },
        {
            accessor: 'created',
            Header: 'Created',
        },
        {
            accessor: 'updated',
            Header: 'Updated',
        }
        
    ];

    return (
        <>
            <SDPageHeader title={sdCamelCaseToFriendlyText(queueType) ?? 'Unknown Queue Title'} me={me} projects={projects} selectedProjectId={selectedProjectId} onProjectChanged={(id) => setSelectedProjectId(id)} showCreateIssue></SDPageHeader>

            <Card >
                <Card.Body className="p-0 pb-2">
                    {tableData == null || tableData.length == 0 ? <i className="mt-4 p-4">No issues in this queue</i> : <></>}

                    {tableData && tableData.length > 0 ? 
                    <AdvanceTableWrapper
                        columns={columns}
                        data={tableData}
                        sortable
                        pagination
                        perPage={25}
                        hover
                    >
                        <AdvanceTable
                            table
                            headerClassName="bg-200 text-900 text-nowrap align-middle"
                            rowClassName="align-middle white-space-nowrap"
                            tableProps={{
                                bordered: true,
                                striped: true,
                                className: 'fs--1 mb-0 overflow-hidden',
                                hover: true
                            }}
                        />
                        <div className="mt-3">
                            <AdvanceTableFooter
                                rowCount={tableData.length}
                                table
                                rowInfo
                                navButtons
                                rowsPerPageSelection
                            />
                        </div>
                    </AdvanceTableWrapper>
                    : <></>}
                </Card.Body>
            </Card>
        </>
    )
}

function ColorCircleWithText({ color = "#FF5733", size = 20, text = "Hello" }) {
  const circleStyle = {
    display: "inline-block",
    width: `${size}px`,
    height: `${size}px`,
    backgroundColor: color,
    borderRadius: "50%",
    verticalAlign: "middle", 
    marginRight: "8px", 
  };

  return (
    <span>
      <span style={circleStyle}></span>
      <span style={{ verticalAlign: "middle" }}>{text}</span>
    </span>
  );
}

export default SDQueue;